module.exports = __webpack_public_path__ + "img/daniele-smc.7c004d75.jpg";